import React, { Component } from 'react';
import PropTypes from 'prop-types';

import axios from 'axios';
import { Button } from '../features/button/index';
import Sidebar from './Sidebar';
import { TEXT } from '../../locals';
import { API } from '../../api';
import { ERROR_MESSAGES } from '../../error_messages';
import { ERROR_TYPES } from '../../errorTypes';
import { setDelay } from '../../util';

const { FORGOT_SIDEBAR } = TEXT.MAIN;

class ForgotPasswordSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = { error: '', disabled: false, emailSend: false };
    this.email = React.createRef();
  }

  clearError = () => {
    const { error } = this.state;
    if (error) {
      this.setState({ error: '' });
    }
    const element = document.getElementById('forgot_email');
    element.classList.remove('error');
  }

  toggleDisable= () => {
    const { disabled } = this.state;
    this.setState({ disabled: !disabled });
  }

  toggleForgetMessage= (action) => {
    this.setState({ emailSend: action });
  }

  onSubmit = (e) => {
    e.preventDefault();
    const { email, toggleDisable, toggleForgetMessage } = this;
    toggleDisable();
    const data = {
      email: email.current.value,
    };
    axios({
      method: 'put',
      url: API.resetPassword,
      data,
    })
      .then(() => {
        setDelay(() => {
          toggleDisable();
          toggleForgetMessage(true);
        });
      })
      .catch((err) => {
        const { data: resData } = err.response || {};
        const { type } = resData || {};
        this.setError(ERROR_MESSAGES[type] || ERROR_MESSAGES.TRY_AGAIN);
        if (type === ERROR_TYPES.USER_NOT_FOUND) {
          const element = document.getElementById('forgot_email');
          element.classList.add('error');
        }
        toggleDisable();
      });
  }

  setError = (error) => {
    this.setState({ error });
  }

  render() {
    const {
      forwardRef, toggleLoginSidebar, toggleRegistrationSidebar, toggleForgotSidebar, active,
    } = this.props;
    const { error, disabled, emailSend } = this.state;
    const { toggleForgetMessage } = this;
    return (
      <Sidebar
        forwardRef={forwardRef}
        toggleShow={toggleForgotSidebar}
        active={active}
      >
        <form onSubmit={this.onSubmit}>
          {emailSend ? <h2 className="title email-sent">{FORGOT_SIDEBAR.RESET_LINK}</h2>
            : (
              <>
                <h2 className="title">{FORGOT_SIDEBAR.TITLE}</h2>
                <div className="info">
                  <label htmlFor="forgot_email">
                    <p>
                      {FORGOT_SIDEBAR.INPUT.EMAIL}
                      <span className="error-text">{` ${error}`}</span>
                    </p>
                    <input
                      id="forgot_email"
                      type="email"
                      pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                      className="email"
                      placeholder={FORGOT_SIDEBAR.PLACEHOLDER.EMAIL}
                      ref={this.email}
                      onChange={this.clearError}
                      disabled={disabled}
                      required
                    />
                  </label>
                </div>
              </>
            )}
          <div className="bottom">
            {!emailSend
            && (
            <Button
              type="submit"
              buttonProps={{
                disabled,
                className: 'main-btn submit',
              }}
              loaderClassName="light-loader"
              label={<h5>{FORGOT_SIDEBAR.SUBMIT_BUTTON}</h5>}
              loading={disabled}
            />
            )}
            <button
              className="transparent-btn"
              onClick={() => {
                toggleForgetMessage(false);
                toggleLoginSidebar(false);
                toggleForgotSidebar(false);
                toggleRegistrationSidebar(true);
              }}
              type="button"
            >
              {FORGOT_SIDEBAR.SIGN_UP_BUTTON}
            </button>
          </div>
        </form>
      </Sidebar>
    );
  }
}
ForgotPasswordSidebar.propTypes = {
  forwardRef: PropTypes.instanceOf(Object).isRequired,
  toggleLoginSidebar: PropTypes.func.isRequired,
  toggleRegistrationSidebar: PropTypes.func.isRequired,
  toggleForgotSidebar: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
};
export default ForgotPasswordSidebar;
